import { render, staticRenderFns } from "./LoginMessage.vue?vue&type=template&id=52185e44&scoped=true&"
import script from "./LoginMessage.vue?vue&type=script&lang=js&"
export * from "./LoginMessage.vue?vue&type=script&lang=js&"
import style0 from "./LoginMessage.vue?vue&type=style&index=0&id=52185e44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52185e44",
  null
  
)

export default component.exports